// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1K4Nq","rootSuccess":"CompleteLink_rootSuccess__1pcaS","rootFailure":"CompleteLink_rootFailure__28trB","isDisabled":"CompleteLink_isDisabled__5C10g"};